export default {
      id: "nav_play-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#nav_play-usage",
      toString: function () {
        return this.url;
      }
    }